/* ABSCENTS v122 — Quiero: la wishlist de toda la tienda vive en Mi perfumero.
   · Con sesión: el corazón guarda en su perfumero (proxy /apps/perfumero/quiero).
   · Sin sesión: se guarda en este navegador y se sube a su perfumero al iniciar sesión.
   · v132: Wishlist King ya se desinstaló; la transición desde Swish terminó (789 clientes migrados). */
(function () {
  'use strict';
  var C = window.abxQuiero || {};
  if (window.__abxQuiero) return;
  window.__abxQuiero = true;

  // la página vieja de Swish lleva a Quiero
  if (/^\/apps\/wishlist/.test(location.pathname)) { location.replace('/pages/perfumero?tab=quiero'); return; }

  var PROXY = (C.proxy || '/apps/perfumero').replace(/\/$/, '');
  var SESION = !!C.sesion;
  var LOGIN = C.login || '/account/login';
  var LOCAL = 'abx-quiero-local';      // invitado: [handle, …] (lo más nuevo primero)
  var CACHE = 'abx-quiero-cache-' + (C.cliente || '');  // con sesión: copia rápida para pintar al instante
  var ALIAS = 'abx-quiero-alias';      // frasco → su decant (el corazón del frasco se ve lleno)

  var S = { handles: [], n: 0, swish: true, listo: false, alias: {} };

  function leer(k, d, ses) { try { var v = (ses ? sessionStorage : localStorage).getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function guardar(k, v, ses) { try { (ses ? sessionStorage : localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }
  function borrar(k, ses) { try { (ses ? sessionStorage : localStorage).removeItem(k); } catch (e) {} }

  function api(metodo, ruta, cuerpo) {
    return fetch(PROXY + ruta, {
      method: metodo, credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cuerpo === undefined ? undefined : JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false }; }).then(function (d) {
        if (!r.ok || !d || !d.ok) { var e = new Error((d && d.motivo) || 'http ' + r.status); e.motivo = d && d.motivo; throw e; }
        return d;
      });
    });
  }

  /* ---------- estado ---------- */
  S.alias = leer(ALIAS, {}, true) || {};
  function ident(h) { return S.alias[h] || h; }
  function tiene(h) { return S.handles.indexOf(ident(h)) >= 0; }
  function aplicar(d) {
    S.handles = d.handles || []; S.n = d.n != null ? d.n : S.handles.length; S.swish = !!d.swish; S.listo = true;
    if (SESION) guardar(CACHE, { handles: S.handles, n: S.n, swish: S.swish }, true);
    pintarTodo();
  }

  /* ---------- pintar ---------- */
  // v135: solo se escribe lo que cambia; reescribir un texto igual dispara el MutationObserver y repintaba en cada cuadro
  function poner(el, txt) { if (el.textContent !== txt) el.textContent = txt; }
  function atr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function pintarBoton(b) {
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var si = tiene(h);
    atr(b, 'aria-pressed', si ? 'true' : 'false');
    if (b.classList.contains('is-on') !== si) b.classList.toggle('is-on', si);
    var t = b.querySelector('.abx-q__txt');
    if (t) poner(t, (si ? t.getAttribute('data-si') : t.getAttribute('data-no')) || '');
    if (!si) {
      var c = document.querySelector('[data-abx-q-cuenta="' + h + '"]');
      if (c) { poner(c, ''); if (c.classList.contains('is-on')) c.classList.remove('is-on'); }
    }
  }
  function pintarTodo() {
    var bs = document.querySelectorAll('[data-abx-q][data-handle]');
    for (var i = 0; i < bs.length; i++) pintarBoton(bs[i]);
    var n = S.n;
    var bur = document.querySelectorAll('[data-abx-q-burbuja]');
    for (var j = 0; j < bur.length; j++) { poner(bur[j], n > 99 ? '99+' : String(n)); if (bur[j].hidden !== !(n > 0)) bur[j].hidden = !(n > 0); }
    // v134: el frasco de Mi perfumero lleva el círculo con el número (arriba) y lo anuncia a lectores de pantalla
    var fs = document.querySelectorAll('.abx-pf-cabecera');
    for (var k = 0; k < fs.length; k++) {
      if (fs[k].classList.contains('is-lleno') !== n > 0) fs[k].classList.toggle('is-lleno', n > 0);
      atr(fs[k], 'aria-label', n > 0 ? 'Mi perfumero, ' + n + (n === 1 ? ' perfume' : ' perfumes') + ' en Quiero' : 'Mi perfumero');
    }
  }
  function cuenta(h, quieren) {
    var c = document.querySelector('[data-abx-q-cuenta="' + h + '"]');
    if (!c || !quieren) return;
    c.textContent = quieren > 1 ? 'Tú y ' + (quieren - 1).toLocaleString('es-MX') + (quieren === 2 ? ' persona más lo quieren' : ' personas más lo quieren') : 'Guardado en tu perfumero';
    requestAnimationFrame(function () { c.classList.add('is-on'); });
  }

  /* ---------- aviso flotante ---------- */
  var tostada, reloj;
  function avisar(html) {
    if (!tostada) {
      tostada = document.createElement('div');
      tostada.className = 'abx-q-tostada';
      tostada.setAttribute('role', 'status');
      document.body.appendChild(tostada);
    }
    tostada.innerHTML = html;
    tostada.classList.add('is-on');
    clearTimeout(reloj);
    reloj = setTimeout(function () { tostada.classList.remove('is-on'); }, 4200);
  }
  var VER = '<a href="/pages/perfumero?tab=quiero">Ver lista</a>';
  // guardar se celebra en la cabecera: el círculo del frasco da un doble latido (sin avisos)
  function latido() {
    var cs = document.querySelectorAll('.abx-pf-cabecera');
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i];
      c.classList.remove('is-latido');
      void c.offsetWidth;
      c.classList.add('is-latido');
    }
    setTimeout(function () { for (var j = 0; j < cs.length; j++) cs[j].classList.remove('is-latido'); }, 1150);
  }

  /* ---------- el corazón ---------- */
  function alternar(b) {
    var h = b.getAttribute('data-handle');
    if (!h || b.dataset.ocupado) return;
    var quiere = !tiene(h);
    b.classList.add('abx-q--pulso');
    setTimeout(function () { b.classList.remove('abx-q--pulso'); }, 420);

    if (!SESION) {
      var l = leer(LOCAL, []).filter(function (x) { return x !== h; });
      if (quiere) l.unshift(h);
      l = l.slice(0, 200);
      guardar(LOCAL, l);
      S.handles = l; S.n = l.length;
      pintarTodo();
      if (quiere) latido();
      return;
    }

    // con sesión: se pinta al momento y se confirma con la respuesta
    var antes = S.handles.slice(), nAntes = S.n;
    if (quiere) { S.handles.unshift(ident(h)); S.n++; } else { S.handles = S.handles.filter(function (x) { return x !== ident(h); }); S.n = Math.max(0, S.n - 1); }
    pintarTodo();
    if (quiere) latido();
    b.dataset.ocupado = '1';
    api('POST', '/quiero', { handle: h, quiero: quiere }).then(function (d) {
      if (d.handle && d.handle !== h) { S.alias[h] = d.handle; guardar(ALIAS, S.alias, true); }
      var lista = S.handles.filter(function (x) { return x !== d.handle && x !== h; });
      if (d.estado === 'quiero') lista.unshift(d.handle);
      S.handles = lista; S.n = d.n;
      guardar(CACHE, { handles: S.handles, n: S.n, swish: S.swish }, true);
      pintarTodo();
      if (d.estado === 'quiero') {
        cuenta(h, d.quieren);
      } else if (d.estado === 'tengo') {
        avisar('Ya está en tu perfumero, en Tengo. ' + '<a href="/pages/perfumero">Ver perfumero</a>');
      }
    }, function (e) {
      S.handles = antes; S.n = nAntes; pintarTodo();
      avisar(e.motivo === 'limite' ? 'Tu perfumero llegó al máximo de perfumes.' : 'No se pudo guardar. Intenta de nuevo.');
    }).then(function () { delete b.dataset.ocupado; });
  }

  document.addEventListener('click', function (ev) {
    // v135: solo los botones de Quiero (con data-handle); el carrito de la cabecera ya no se confunde con uno
    var b = ev.target.closest && ev.target.closest('[data-abx-q][data-handle]');
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();
    alternar(b);
  }, true);

  // tarjetas que llegan después (filtros, "cargar más", recomendaciones)
  var pendiente = false;
  // v135: solo cuando llegan elementos nuevos; los textos que pinta este archivo no cuentan
  new MutationObserver(function (rs) {
    if (pendiente) return;
    var nuevo = false;
    for (var a = 0; a < rs.length && !nuevo; a++) {
      var ns = rs[a].addedNodes;
      for (var z = 0; z < ns.length; z++) if (ns[z].nodeType === 1) { nuevo = true; break; }
    }
    if (!nuevo) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; pintarTodo(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- invitado: su lista en Mi perfumero ---------- */
  function dinero(c) { return '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // v126: la lista del invitado también se compra desde aquí: tamaño plegable, precio, "+" y "Agregar todo"
  var INV = {};                       // handle → variantes [{id, ml, titulo, precio, disp}]
  var SEL = 'abx-q-sel';              // la misma elección de tamaño que usa Mi perfumero
  var MAS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  function txtMl(v) { return v.ml ? v.ml + ' ml' : (/default/i.test(v.titulo) ? 'Único' : v.titulo); }
  function varianteInv(h) {
    var vs = INV[h]; if (!vs) return null;
    var disp = vs.filter(function (v) { return v.disp; });
    if (!disp.length) return null;
    var sel = leer(SEL, {})[h];
    var g = sel && disp.filter(function (v) { return v.id === sel; })[0];
    if (g) return g;
    var tres = disp.filter(function (v) { return v.ml === 3; })[0];
    if (tres) return tres;
    var arriba = disp.filter(function (v) { return v.ml > 3; }).sort(function (a, b) { return a.ml - b.ml; })[0];
    return arriba || disp.sort(function (a, b) { return b.ml - a.ml; })[0];
  }
  function compraInv(h) {
    var vs = INV[h]; if (!vs) return '';
    var sel = varianteInv(h);
    if (!sel) return '<span class="abx-q-nota abx-q-nota--agotado">Agotado</span>';
    var orden = vs.slice().sort(function (a, b) { return a.ml - b.ml; });
    var varios = orden.length > 1;
    return '<div class="abx-q-buy" data-qi-buy="' + esc(h) + '"><div class="abx-q-buy__fila">' +
      (varios ? '<button type="button" class="abx-q-sel" data-qi="abrir" aria-expanded="false" aria-label="Cambiar tamaño"><span data-q-ml>' + esc(txtMl(sel)) + '</span><i aria-hidden="true"></i></button>'
              : '<span class="abx-q-sel abx-q-sel--fijo">' + esc(txtMl(sel)) + '</span>') +
      '<span class="abx-q-precio" data-q-precio>' + dinero(sel.precio) + '</span>' +
      '<button type="button" class="abx-q-mas" data-qi="mas" aria-label="Agregar al carrito">' + MAS + '</button></div>' +
      (varios ? '<span class="abx-q-tams" role="radiogroup">' + orden.map(function (v) {
        var on = v.id === sel.id;
        return '<button type="button" class="abx-q-tam' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '"' + (v.disp ? '' : ' disabled') +
          ' data-qi="tam" data-v="' + v.id + '"><span>' + esc(txtMl(v)) + '</span><em>' + (v.disp ? dinero(v.precio) : 'agotado') + '</em></button>';
      }).join('') + '</span>' : '') + '</div>';
  }
  function barraInv(caja) {
    var b = caja.querySelector('[data-qi-todo]'); if (!b) return;
    var n = 0, total = 0, agot = 0;
    leer(LOCAL, []).forEach(function (h) { if (!INV[h]) return; var v = varianteInv(h); if (v) { n++; total += v.precio; } else agot++; });
    if (!n) { b.hidden = true; return; }
    b.hidden = false;
    b.innerHTML = '<span class="abx-q-todo__txt"><b>' + n + (n === 1 ? ' perfume' : ' perfumes') + ' · ' + dinero(total) + '</b>' +
      '<small>Cada uno en el tamaño que elegiste' + (agot ? ' · ' + agot + (agot === 1 ? ' agotado se queda' : ' agotados se quedan') + ' en tu lista' : '') + '</small></span>' +
      '<button type="button" class="abx-q-todo__btn" data-qi="todo">Agregar todo al carrito</button>';
  }
  function plegarInv(c) { c.classList.remove('is-open'); var t = c.querySelector('[data-qi="abrir"]'); if (t) t.setAttribute('aria-expanded', 'false'); }
  function alCarritoInv(ids, btn) {
    if (!ids.length) return;
    var icono = btn.classList.contains('abx-q-mas'), antes = btn.innerHTML;
    btn.disabled = true; if (icono) btn.classList.add('is-busy'); else btn.textContent = 'Agregando…';
    var volver = function () { btn.disabled = false; btn.classList.remove('is-busy', 'is-ok'); btn.innerHTML = antes; };
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        btn.classList.remove('is-busy');
        if (!x.ok) { volver(); avisar((x.d && x.d.description) || 'No se pudo agregar al carrito'); return; }
        if (icono) { btn.classList.add('is-ok'); btn.innerHTML = '✓'; } else btn.textContent = ids.length > 1 ? '✓ Agregados' : '✓ Agregado';
        setTimeout(volver, 1600);
        var prod = x.d && x.d.items ? x.d.items[x.d.items.length - 1] : x.d;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: prod, addToCartBtn: btn } }));
        var html = document.documentElement, t0 = Date.now();
        var tm = setInterval(function () {
          if (html.classList.contains('cart-open') || Date.now() - t0 > 8000) { clearInterval(tm); return; }
          document.dispatchEvent(new CustomEvent('cart:open'));
        }, 250);
      }, function () { volver(); avisar('No se pudo agregar al carrito'); });
  }
  var invEventos = false;
  function eventosInv(caja) {
    if (invEventos) return; invEventos = true;
    caja.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-qi]');
      if (!b) return;
      ev.preventDefault();
      var acc = b.getAttribute('data-qi'), cb = b.closest('[data-qi-buy]'), h = cb && cb.getAttribute('data-qi-buy');
      if (acc === 'abrir') {
        var abrir = !cb.classList.contains('is-open');
        caja.querySelectorAll('[data-qi-buy].is-open').forEach(plegarInv);
        if (abrir) { cb.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
      } else if (acc === 'tam') {
        var id = Number(b.getAttribute('data-v')), v = (INV[h] || []).filter(function (x) { return x.id === id && x.disp; })[0];
        if (!v) return;
        var sel = leer(SEL, {}); sel[h] = id; guardar(SEL, sel);
        Array.prototype.forEach.call(b.parentNode.children, function (c) { var on = c === b; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
        cb.querySelector('[data-q-ml]').textContent = txtMl(v);
        cb.querySelector('[data-q-precio]').textContent = dinero(v.precio);
        plegarInv(cb); barraInv(caja);
      } else if (acc === 'mas') {
        var vm = varianteInv(h); if (vm) alCarritoInv([vm.id], b);
      } else if (acc === 'todo') {
        var ids = [];
        leer(LOCAL, []).forEach(function (hh) { var x = INV[hh] && varianteInv(hh); if (x) ids.push(x.id); });
        alCarritoInv(ids, b);
      }
    });
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest || ev.target.closest('[data-qi-buy]')) return;
      caja.querySelectorAll('[data-qi-buy].is-open').forEach(plegarInv);
    });
  }
  function listaInvitado() {
    var caja = document.getElementById('abx-q-invitado');
    if (!caja || SESION) return;
    var l = leer(LOCAL, []);
    if (!l.length) { caja.hidden = true; return; }
    caja.hidden = false;
    eventosInv(caja);
    caja.innerHTML = '<div class="abx-q-inv__cab"><span class="abx-q-inv__eyebrow">Tu lista Quiero</span>' +
      '<p>Está guardada en este navegador. <a href="' + LOGIN + '">Inicia sesión</a> y pasa sola a tu perfumero.</p></div>' +
      '<div class="abx-q-todo" data-qi-todo hidden></div>' +
      '<div class="abx-q-inv__grid"></div>';
    var grid = caja.querySelector('.abx-q-inv__grid');
    l.slice(0, 60).forEach(function (h) {
      var el = document.createElement('div');
      el.className = 'abx-q-inv__item';
      grid.appendChild(el);
      fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) { el.remove(); return; }
        INV[h] = (p.variants || []).map(function (v) { return { id: v.id, ml: parseInt(String(v.title).replace(/[^\d]/g, ''), 10) || 0, titulo: v.title, precio: v.price, disp: !!v.available }; });
        var url = '/products/' + encodeURIComponent(h);
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > 0 ? '&' : '?') + 'width=300' : '';
        el.innerHTML = '<span class="abx-q-inv__foto"><a href="' + url + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</a>' +
          '<button type="button" class="abx-q abx-q--tarjeta" data-abx-q data-handle="' + esc(h) + '" aria-pressed="true" aria-label="Quitar de Quiero">' +
          '<svg class="abx-q__svg" viewBox="0 0 64 64" aria-hidden="true"><path d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/></svg></button></span>' +
          '<a class="abx-q-inv__txt" href="' + url + '"><span class="abx-q-inv__marca">' + esc(p.vendor) + '</span><span class="abx-q-inv__nombre">' + esc(p.title) + '</span></a>' +
          compraInv(h);
        barraInv(caja);
        pintarTodo();
      }, function () {});
    });
  }

  /* ---------- arranque ---------- */
  function arrancar() {
    if (!SESION) {
      var l = leer(LOCAL, []);
      S.handles = l; S.n = l.length; S.listo = true;
      pintarTodo();
      listaInvitado();
      return;
    }
    var c = leer(CACHE, null, true);
    if (c) { S.handles = c.handles || []; S.n = c.n || 0; S.swish = !!c.swish; pintarTodo(); }
    var fila = document.querySelector('[data-abx-q-cuenta]');
    var q = fila ? '?handle=' + encodeURIComponent(fila.getAttribute('data-abx-q-cuenta')) : '';
    // lo que guardó como invitado se sube primero
    var local = leer(LOCAL, []);
    var paso = local.length
      ? api('POST', '/quiero/fusionar', { handles: local, origen: 'invitado' }).then(function (d) {
          borrar(LOCAL);
          if (d.agregados) latido();
          return q ? api('GET', '/quiero' + q) : d;
        })
      : api('GET', '/quiero' + q);
    paso.then(function (d) {
      aplicar(d);
      if (fila && d.quieren && d.identidad) cuenta(fila.getAttribute('data-abx-q-cuenta'), d.quieren);
    }, function () {});
  }

  /* ---------- en Mi perfumero ---------- */
  function enPerfumero() {
    var pf = document.getElementById('abx-pf');
    if (!pf || !SESION) return;
    // ?tab=quiero abre la pestaña Quiero (una vez, cuando la app ya pintó)
    if (/[?&]tab=quiero\b/.test(location.search)) {
      var t0 = Date.now();
      (function abrir() {
        var b = pf.querySelector('.abx-pf-tab[data-tab="quiero"]');
        if (b) { if (b.getAttribute('aria-selected') !== 'true') b.click(); return; }
        if (Date.now() - t0 < 10000) setTimeout(abrir, 250);
      })();
    }
    // lo más deseado (solo ABSCENTS), junto a la moderación
    var caja = null, filtro = '', datos = null;
    function vista() {
      if (location.hash !== '#moderar') { if (caja) caja.hidden = true; return; }
      if (!caja) {
        caja = document.createElement('div');
        caja.className = 'abx-pf-mod abx-q-deseo';
        var app = document.getElementById('abx-pf-app');
        (app && app.parentNode ? app.parentNode : pf).insertBefore(caja, app ? app.nextSibling : null);
        caja.addEventListener('click', function (ev) {
          var f = ev.target.closest('[data-deseo-filtro]');
          if (!f) return;
          filtro = f.getAttribute('data-deseo-filtro');
          cargar();
        });
      }
      caja.hidden = false;
      if (!datos) cargar(); else pintarDeseo();
    }
    function cargar() {
      api('GET', '/moderar/quiero' + (filtro ? '?filtro=' + filtro : '')).then(function (d) { datos = d; pintarDeseo(); }, function () { if (caja) caja.hidden = true; });
    }
    function pintarDeseo() {
      if (!caja || !datos) return;
      var t = datos.totales || {};
      var lista = datos.lista || [];
      var h = '<span class="abx-pf-eyebrow">Solo ABSCENTS</span><h2>Lo más deseado</h2>' +
        '<p class="abx-pf-perfil__intro">' + (t.perfumes || 0).toLocaleString('es-MX') + ' perfumes en la lista Quiero de ' + (t.clientes || 0).toLocaleString('es-MX') + ' clientes.' +
        (t.avisosEnCola ? ' ' + t.avisosEnCola + ' avisos de "volvió / bajó" esperando turno.' : '') + '</p>' +
        '<div class="abx-pf-tabs" role="tablist" aria-label="Filtro">' + [['', 'Todo'], ['agotados', 'Agotados']].map(function (f) {
          return '<button type="button" role="tab" class="abx-pf-tab" data-deseo-filtro="' + f[0] + '" aria-selected="' + (filtro === f[0]) + '">' + f[1] + '</button>';
        }).join('') + '</div>';
      if (!lista.length) h += '<div class="abx-pf-vacio"><p>' + (filtro ? 'Nada agotado entre lo más deseado.' : 'Todavía nadie guarda perfumes en Quiero.') + '</p></div>';
      else h += '<ol class="abx-q-deseo__lista">' + lista.slice(0, 40).map(function (it, i) {
        var est = it.disponible === false ? '<span class="abx-pf-motivo abx-pf-motivo--rojo">Agotado</span>' : '';
        var img = it.imagen ? '<img src="' + esc(it.imagen) + (it.imagen.indexOf('?') > 0 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="abx-q-deseo__img"></span>';
        return '<li class="abx-q-deseo__fila"><span class="abx-q-deseo__n">' + (i + 1) + '</span>' + img +
          '<a class="abx-q-deseo__tx" href="/products/' + encodeURIComponent(it.handle) + '"><span class="abx-pf-meta">' + esc(it.marca) + '</span><b>' + esc(it.titulo) + '</b></a>' +
          est + '<span class="abx-q-deseo__c">' + Number(it.quieren).toLocaleString('es-MX') + '<small>lo quieren</small></span></li>';
      }).join('') + '</ol>';
      caja.innerHTML = h;
    }
    window.addEventListener('hashchange', vista);
    vista();
  }

  // Mi perfumero avisa cuando cambia algo de Quiero desde su página
  window.addEventListener('abx-quiero:refrescar', function () {
    borrar(CACHE, true);
    if (SESION) api('GET', '/quiero').then(aplicar, function () {});
  });

  function inicio() { arrancar(); enPerfumero(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio); else inicio();
})();
